export default "__VITE_ASSET__cff6478b__"